import { render } from "./Label.vue?vue&type=template&id=21824b59&scoped=true&ts=true"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"

import "./Label.vue?vue&type=style&index=0&id=21824b59&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21824b59"]])

export default __exports__